import React, { useState } from 'react'
import VoucherTemplatePicker from 'app/main/dealsPromotions/VoucherTemplatePicker'
import { FormattedMessage } from 'react-intl'

export default (props) => {
  const { templates, onSelected } = props
  const [open, setOpen] = useState(false)
  const onOpenTemplate = () => {
    setOpen(true)
  }

  return (
    <>
      <div
        className="cursor-pointer p-5 underline text-blue"
        onClick={onOpenTemplate}
      >
        <FormattedMessage id="voucher.dialog.choose.templates.text" />
      </div>
      <VoucherTemplatePicker
        isOpen={open}
        voucherTemplateData={templates}
        onApply={(data) => {
          onSelected(data)
          setOpen(false)
        }}
        onCancel={() => setOpen(false)}
      />
    </>
  )
}
